import { Action, ActionNames, State } from './types'

export const INITIAL_STATE = {
  layers: {
    others: true,
    pattern: false,
    warehouses: true,
    borderPoints: false,
  }
}

export const viewReducer = (state: State, action: Action) => {
  switch (action.type) {
    case ActionNames.updateLayer:
      return { ...state, layers: { ...state.layers, ...action.payload } }

    default: return state
  }
}